import { styled } from '@mui/material/styles';
import { Box, Typography, FormControl, RadioGroup, Button } from '@mui/material';

// Re-exporting common styles or define them if they slightly differ
export { FormPageContainer, FormHeader, FormSubHeader, StyledForm, SubmitButton} from './PersonalDetailsForm.styles';

// Specific styles for MaritalStatusForm
export const SectionSubHeader = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.primary, // Or a slightly different emphasis color
    marginTop: theme.spacing(3.5),
    marginBottom: theme.spacing(1.5),
    fontWeight: 500,
}));


export const RadioGroupContainer = styled(FormControl)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: '100%',
}));


export const StyledRadioGroup = styled(RadioGroup)({
    flexDirection: 'row', // Display radio buttons horizontally if desired
    gap: '20px',
    flexWrap: 'wrap',
});


export const ButtonGroupContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing(4),
  gap: theme.spacing(2),
  flexWrap: 'wrap', // Allow buttons to wrap on smaller screens
  '& > *': { // Target direct children (buttons)
      flexGrow: 1, // Make buttons grow equally
      minWidth: '120px', // Ensure buttons have a minimum width
      '@media (max-width: 600px)': {
          width: '100%', // Stack buttons on small screens
          flexGrow: 0,
      },
  }
}));

export const BackButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5, 2.5),
    fontWeight: 600,
    background: theme.palette.primary.main,
  }));